// extracted by mini-css-extract-plugin
export default {"heading":"LZ8EEmyIfz","template-info":"_9+Fg9OhKJP","templateInfo":"_9+Fg9OhKJP","name":"lHZBsrKbwb","info":"XuqvvDYw4U","description":"Fhw1QnqyeB","divider":"_7hZ3AzxBKy","h-rule":"YCHKYjjmWS","hRule":"YCHKYjjmWS","logo":"MH825VQzPt"};
    if(module.hot) {
      // 1650538153586
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  